export default [
  {
    type: 'email',
    name: 'emailAddress',
    label: 'Email Address',
    validation: '^required|email'
  },
  {
    component: 'div',
    class: 'grid grid-cols-2 gap-4',
    children: [
      {
        type: 'text',
        name: 'driverName',
        label: 'Full Name',
        validation: 'required'
      },
      {
        type: 'date',
        name: 'driverDateOfBirth',
        label: 'Date Of Birth',
        validation: 'required'
      },
    ]
  },
  {
    component: 'div',
    class: 'grid grid-cols-2 gap-4',
    children: [
      {
        type: 'text',
        name: 'driversLicenseNumber',
        label: 'Licence Number',
        validation: 'required'
      },
      {
        type: 'date',
        name: 'driversLicenseExpiry',
        label: 'Licence Expiry',
      },
    ]
  },
]